import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to get a user's current leaderboard position (1-10)
 * Returns null if user is not in top 10 OR if user is anonymous
 */
export function useLeaderboardPosition(userId) {
  return useQuery({
    queryKey: ["leaderboard-position", userId],
    queryFn: async () => {
      if (!userId) return null;

      // Fetch tracks ordered by praise_count to determine position
      const { data: tracks, error } = await supabase
        .from("tracks")
        .select("id, artist_id, praise_count")
        .eq("is_active", true)
        .order("praise_count", { ascending: false })
        .limit(10);
      
      if (error || !tracks || tracks.length === 0) return null;

      // Find the user's highest ranked track
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].artist_id === userId) {
          return i + 1; // Position (1-based)
        }
      }

      return null; // Not in top 10
    },
    enabled: !!userId,
    staleTime: 30000,
    gcTime: 60000,
  });
}

